import '../styles/globals.css';
import type {AppProps} from 'next/app';
import Head from 'next/head';
import {ThemeProvider} from '@mui/material/styles';
import {defaultTheme} from '@local/theme/defaultTheme';
import {Provider} from 'react-redux';
import {store} from '@local/redux/store';
import {GlobalSnackbar} from '@local/components/global/snackbar';
import {Page} from '@local/components/global/page';
import {StateCleaner} from '@local/components/global/stateCleaner';
import {DispatchConnector} from '@local/components/global/dispatchConnector';
import {RouterConnector} from '@local/components/global/routerConnector';
import {UserConnector} from '@local/components/global/userConnector';
import {startMonitoring} from '@local/logics/datadog/startMonitoring';

startMonitoring();

export default function MyApp({Component, pageProps}: AppProps) {
  return (
    <>
      <Head>
        <meta name='viewport' content='initial-scale=1, width=device-width' />
        <meta name={'robots'} content={'noindex'} />
        <link rel='apple-touch-icon' sizes='180x180' href='/apple-touch-icon.png' />
        <link rel='icon' type='image/png' sizes='32x32' href='/favicon-32x32.png' />
        <link rel='icon' type='image/png' sizes='16x16' href='/favicon-16x16.png' />
        <link rel='manifest' href='/site.webmanifest' />
        <link rel='mask-icon' href='/safari-pinned-tab.svg' color='#5bbad5' />
        <meta name='msapplication-TileColor' content='#da532c' />
        <meta name='theme-color' content='#ffffff' />
      </Head>
      <Provider store={store}>
        <ThemeProvider theme={defaultTheme}>
          <Page Component={Component} pageProps={pageProps} />
          <GlobalSnackbar />
        </ThemeProvider>
        <StateCleaner />
        <DispatchConnector />
        <RouterConnector />
        <UserConnector />
      </Provider>
    </>
  );
}
